<template>
  <div>
    <Row class-name="m-wrap">
      <Col span="8" v-for="(box, idx) in resource" :key="idx" class-name="m-box">
        <plan-box
          v-model="box.keyword"
          :title="box.title"
          :data="box.data"
          :level="box.level"
          :disabled="box.disabled"
          :loading="box.loading"
          @on-select="selectAll"
        >
          <plan-item
            v-model="box.current"
            :data="box.data"
            :keyword="box.keyword"
            :level="box.level"
            :icon-lock="box.lock"
            :disabled="box.disabled"
            @on-child="pushChild"
            @on-select="selectAll"
          />
        </plan-box>
      </Col>
    </Row>
  </div>
</template>
<script>
import PlanBox from './plan-box'
import PlanItem from './plan-item'
import { isArray } from '@/common/js/utils'
import { getAdTreeList } from '@/api/manage.model'
export default {
  name: 'selectPlan',
  components: { PlanBox, PlanItem },
  props: {
    subMedia: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    media: {
      type: [Number, String]
    },
    loading: {
      type: Boolean,
      default: false
    },
    preload: {
      type: Boolean,
      default: false
    },
    planIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    bindGetData(val) {
      // 编辑状态显示时更新数据
      val && this.$set(this.resource[0], 'keyword', '')
      this.preload && this.updateResource(val)
    },
    updateResource(val) {
      if (val) {
        let current = this.data[0] ? this.data[0].id : ''
        this.resource[0].data = this.data
        this.data.some((ret) => {
          const hasCheck =
            ret.children &&
            ret.children.some((met) => {
              return met.children && met.children.some((t) => t.check)
            })
          if (hasCheck) {
            current = ret.id
            return true
          }
        })
        this.pushChild({ level: 1, current })
      } else this.initData()
    },
    initData() {
      this.resource = [
        {
          title: '账号',
          level: 1,
          lock: true,
          current: 442,
          keyword: '',
          data: []
        },
        {
          title: '计划组/计划',
          level: 2,
          current: '',
          keyword: '',
          loading: false,
          data: []
        },
        {
          title: '计划/单元',
          level: 3,
          current: '',
          keyword: '',
          loading: false,
          data: []
        }
      ]
    },
    selectAll({ level, check, cat, keyword }) {
      const index = level - 2
      let current = index > -1 ? this.resource[index].current : ''
      cat && (current = cat)
      this.$emit('on-select', {
        check,
        current,
        list: this.data,
        keyword
      })
    },
    pushChild({ level, current }) {
      const len = this.resource.length
      const append = []
      const childId = (this.resource[1] && this.resource[1].current) || ''
      const { children, lock, xhr } = this.data.filter((ret) => ret.id === current).pop() || {}
      this.resource[level - 1].current = current
      if (level === 1) {
        // 账号
        const index = this.data.findIndex((ret) => ret.id === current)
        const accounts = index > -1 ? this.data[index] : {}
        if (!xhr && current) {
          // 未加载过数据
          this.resource[level].loading = true
          this.resource[level + 1].loading = true
          const params = {
            mediaId: this.media === -10 ? 10 : this.media,
            adAccountId: current,
            subMediaId: this.subMedia
          }
          getAdTreeList(params).then((data) => {
            this.resource[level].loading = false
            this.resource[level + 1].loading = false
            this.resource.splice(level, len - level)
            if (isArray(data) && data.length) {
              const { adGroupList } = data.pop()
              accounts.children = adGroupList.map((meta) => {
                const group = {
                  id: meta.adGroup.id,
                  name: meta.adGroup.name,
                  children: meta.adPlanList.map((t) => {
                    t.plan = true
                    // 处理计划
                    if (lock) t.check = true
                    else if (this.planIds.includes(t.id)) t.check = true
                    return t
                  })
                }
                if (lock) group.check = true
                return group
              })
              accounts.xhr = true
              this.handleChildPush(accounts.children, childId, lock)
            } else {
              accounts.xhr = true
              this.handleChildPush([], childId, lock)
            }
          })
        } else {
          this.resource.splice(level, len - level)
          this.handleChildPush(children, childId, lock)
        }
      } else if (level === 2) {
        this.resource.splice(level, len - level)
        const { children, lock } = this.data.filter((ret) => ret.id === this.resource[0].current).pop() || {}
        if (isArray(children)) {
          const items = children.filter((ret) => ret.id === current).pop()
          if (items && isArray(items.children)) {
            append.push({
              title: '计划/单元',
              level: 3,
              current: '',
              keyword: '',
              loading: false,
              disabled: lock,
              data: items.children
            })
          } else {
            append.push({
              title: '计划/单元',
              level: 3,
              current: '',
              keyword: '',
              loading: false,
              disabled: lock,
              data: []
            })
          }
        } else {
          append.push({
            title: '计划/单元',
            level: 3,
            current: '',
            keyword: '',
            loading: false,
            disabled: lock,
            data: []
          })
        }
        this.resource.push(...append)
      }
    },
    handleChildPush(children, childId, lock) {
      const append = []
      if (isArray(children) && children.length) {
        const index = children.findIndex((ret) => ret.id === childId)
        const child = index > -1 ? children[index].id : children[0].id
        const items = index > -1 ? children[index].children : children[0].children
        append.push({
          title: '计划组/计划',
          level: 2,
          current: child,
          keyword: '',
          loading: false,
          disabled: lock,
          data: children
        })
        append.push({
          title: '计划/单元',
          level: 3,
          current: '',
          keyword: '',
          loading: false,
          disabled: lock,
          data: items
        })
      } else {
        // 空账号
        append.push({
          title: '计划组/计划',
          level: 2,
          current: '',
          keyword: '',
          loading: false,
          disabled: lock,
          data: []
        })
        append.push({
          title: '计划/单元',
          level: 3,
          current: '',
          keyword: '',
          loading: false,
          disabled: lock,
          data: []
        })
      }
      this.resource.push(...append)
    }
  },
  watch: {
    loading(nVal) {
      if (!nVal && !this.preload) this.updateResource(!nVal)
    }
  },
  data() {
    return {
      resource: []
    }
  },
  created() {
    this.initData()
  }
}
</script>
<style lang="scss" scoped>
.m-wrap {
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  .m-box {
    border-top: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
  }
}
</style>
